const Logger = {
  error: function(message) {
    Logger.log(message, 'error');
  },

  info: function(message) {
    Logger.log(message, 'info');
  },

  log: function (message, type) {
    $.ajax({type: 'POST', url: '/syslog', data: {message: message, type: type}, dataType: 'json'}).always(function(e) {
      console.log(type, message, e && e.responseText || '')
    });
  }
}